import { useLang } from "@/lib/i18n";

/**
 * Two-letter pill that flips between EN and RU. Sits in the layout
 * header next to the balance/profile menu so the customer can switch
 * the SPA's language at any time. Choice persists in localStorage.
 */
export function LangSwitcher() {
  const lang = useLang((s) => s.lang);
  const setLang = useLang((s) => s.setLang);
  const next = lang === "ru" ? "en" : "ru";
  return (
    <button
      type="button"
      onClick={() => setLang(next)}
      title={lang === "ru" ? "Switch to English" : "Переключить на русский"}
      className="rounded border border-surface-border bg-white px-2 py-1 text-xs font-medium text-slate-700 hover:bg-slate-50"
    >
      {lang === "ru" ? "RU" : "EN"}
    </button>
  );
}
